import { useLanguage } from "@utils/hooks/useLanguage";
import { IPlayer } from "./Players";
import HorizontalListWithArrows from "@components/StatsConsole/Widgets/LineupWidget/parts/HorizontalLists/HorizontalListWithArrows";
import { useTranslations } from "../../../../../translation/TranslationContext";
import { T } from "@utils/enums";
import { useVersion } from "@utils/hooks/useVersion";
import { useTheme } from "@stores/ThemeContext";
import { useContext } from "react";
import { StateContext } from "../../../../../state/stateContext";
import { sortPlayers } from "@components/StatsConsole/Widgets/LineupWidget/parts/HorizontalLists/hooks/sortingPlayers";

interface BenchProps {
    homePlayers: IPlayer[];
    awayPlayers: IPlayer[];
    homeTeamName?: string | null;
    awayTeamName?: string | null;
    isLastSection?: boolean;
}

const Bench = ({ homePlayers, awayPlayers, homeTeamName, awayTeamName, isLastSection = false }: BenchProps) => {
    const language = useLanguage();
    const t = useTranslations(language);
    const { isV1 } = useVersion();
    const { theme } = useTheme();
    const ctx = useContext(StateContext);
    const { stContext } = ctx || {};
    const { activeTooltipPlayerId } = stContext || {};
    
    const sortedAwayPlayers = sortPlayers(awayPlayers, false);
    
    const hasMorePlaceForTooltip = isLastSection && activeTooltipPlayerId && 
        sortedAwayPlayers.some((player, index) => `${index}${player?.name}` === activeTooltipPlayerId);
    
    const containerHeight = hasMorePlaceForTooltip ? '310px' : '252px';

    
    return (
        <div data-testid="bench-container" className={`bg-monoY dark:bg-base110 rounded-[4px] overflow-visible transition-all duration-300 mb-[4px]`}
            style={{ 
                height: containerHeight,
                minHeight: containerHeight,
                backgroundColor: isV1 ? (theme === T.LIGHT ? '#FFFFFF' : '#333333') : (theme === T.LIGHT ? '#FFFFFF' : '#222222') 
            }}>
            <div data-testid="bench-title" className="w-full h-[24px] flex justify-center items-center mb-[0px]
                            font-medium text-[16px] leading-[24px] text-monoX dark:text-monoY">
                {t[`InHouseStats.LineupBench`]}
            </div>
            <div data-testid="bench-home-team-name" className={`ml-[12px] w-full font-medium text-[16px] leading-[24px] text-monoX dark:text-monoY mb-[12px] pr-[16px] truncate`}>
                {homeTeamName}
            </div>
            <HorizontalListWithArrows mb="mb-[16px]" players={homePlayers} name={homeTeamName} team="home" />
            <div data-testid="bench-away-team-name" className={`ml-[12px] w-full font-medium text-[16px] leading-[24px] text-monoX dark:text-monoY mb-[12px] pr-[16px] truncate`}>
                {awayTeamName}
            </div>
            <HorizontalListWithArrows mb="mb-[16px]" players={awayPlayers} name={awayTeamName} team="away" />
        </div>
    )
}

export default Bench;